<template>
  <div
    class="app-toast"
    :class="[`app-toast--${color}`, { 'app-toast--dismissible': dismissible }]"
    role="alert"
    aria-live="polite"
  >
    <span class="app-toast__icon" aria-hidden="true">
      <i :class="resolvedIcon" />
    </span>
    <p class="app-toast__text">
      <slot />
    </p>
    <button
      v-if="dismissible"
      type="button"
      class="app-toast__close"
      aria-label="Close"
      @click="$emit('dismiss')"
    >
      <i class="bi bi-x-lg" aria-hidden="true"></i>
    </button>
  </div>
</template>

<script>
const DEFAULT_ICONS = {
  success: "bi bi-check-circle-fill",
  danger: "bi bi-x-circle-fill",
  warning: "bi bi-exclamation-triangle-fill",
  info: "bi bi-info-circle-fill",
};

export default {
  name: "SoftAlert",
  props: {
    color: {
      type: String,
      default: "success",
    },
    icon: {
      type: String,
      default: "",
    },
    dismissible: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["dismiss"],
  computed: {
    resolvedIcon() {
      if (this.icon) {
        return this.icon;
      }

      return DEFAULT_ICONS[this.color] || DEFAULT_ICONS.info;
    },
  },
};
</script>
